import {Component} from 'preact';
import appLogger from '@core/LoggingProvider'
import $ from '@modules/jquery-import';
import compose from 'ramda/src/compose';
import pathOr from 'ramda/src/pathOr';
import Provider from 'preact-context-provider';
import BrandReviewsService from '@services/BrandReviews/';
import {Query} from 'react-apollo';
import {GetBrandReviewSummary} from '@services/BrandReviews/query.graphql';
import {getParameters} from '@util/URLUtils';
import User from '@modules/User';
import CustomerReviews from './CustomerReviews';
import ReviewSummary from '@components/customerReviews/ReviewSummary';

export const
    QUERTSTRING_INDEX = 'reviewPageIndex',
    QUERYSTRING_FILTERS = 'reviewFilters[]',
    DELETE_REVIEW = 'deleteReview',
    DELETE_COMMENT = 'deleteComment',
    DENY_REVIEW = 'denyReview',
    RESPOND_REVIEW = 'respondToReview',
    DEFAULT_FILTERS = {
        rating: 'ALL RATINGS',
        status: 'ALL STATUSES',
        userReviews: 'ALL REVIEWS'
    };

const productModel = pathOr( {id: null}, ['upi', 'apps', 'productpage', 'ProductModel'], window );

class CustomerReviewsContainer extends Component {
    state = {
        errors: {},
        user: User.getInfo(),
        filters: DEFAULT_FILTERS,
        brandId: productModel.id,
        lastRequestIndex: 0,
        requestCount: 10,
        modals: {
            [DENY_REVIEW]: false,
            [RESPOND_REVIEW]: false,
            [DELETE_REVIEW]: false,
            [DELETE_COMMENT]: false
        }
    };

    componentWillMount() {
        this.parseQueryString( getParameters() );
    }

    componentDidMount() {
        const hash = window.location.hash;
        // perform side-effect
        // scroll to selected review from location.has e.g. ...#customer-review-123
        if ( hash.includes( 'customer-review' ) ) {
            $( '.accordion' ).trigger( {type: 'open:accordion', item: $( '#section-reviews' )} );

            setTimeout( () => {
                const selectedReview = $( hash );
                if ( selectedReview[0] ) {
                    selectedReview.scrollToElement()
                }
            }, 2000 );
        }
    }

    parseQueryString( params ) {
        const pageIndex = params[QUERTSTRING_INDEX];
        const filters = params[QUERYSTRING_FILTERS];

        if ( pageIndex ) {
            this.setPageIndex( pageIndex );
        }
        if ( filters ) {
            this.setFiltersFromQueryString( filters );
        }
    }

    getPaginationVars = ( params = {} ) => {
        const {brandId, requestCount, filters, lastRequestIndex} = this.state;

        return {
            brandId,
            requestCount,
            ...filters,
            lastRequestIndex: params.newIndex || lastRequestIndex
        }
    };

    setFiltersFromQueryString( params = [] ) {
        // note -> filter review by querystring e.g. ?reviewFilters[]=status,pending&reviewFilters[]=rating,3
        // map filters to expected format
        const filters = params.reduce( ( acc, next ) => {
            const parts = next.split( ',' );
            acc[parts[0]] = parts[1].toUpperCase();
            return acc;
        }, {} );

        this.setFilters( filters );
    }

    setPageIndex( newIndex ) {
        this.setState( {lastRequestIndex: parseInt( newIndex )} );
    }

    setError = ( name, error ) => this.setState( {errors: {...this.state.errors, [name]: error}} );

    removeError = ( name ) => this.setState( {errors: {...this.state.errors, [name]: false}} );

    setFilters = newFilters => {
        const filters = {
            ...this.state.filters,
            ...newFilters
        };
        this.setState( {filters} );
        return filters;
    };

    clearFilters = () => this.setFilters( DEFAULT_FILTERS );

    onFilterChange = () => {
        const queryVars = this.getPaginationVars( {newIndex: 0} );
        return BrandReviewsService.filterUpdateStrategy( queryVars );
    };

    onLoadMore = ( newIndex ) => {
        const queryVars = this.getPaginationVars( {newIndex} );
        return BrandReviewsService.paginationUpdateStrategy( queryVars );
    };

    handleLoadMore = async ( newIndex ) => {
        this.removeError( 'pagination' );
        try {
            return await this.fetchMore( this.onLoadMore( newIndex ) );
        }
        catch ( err ) {
            console.error( `[CustomerReviews.LoadMore Error] ${err}` );
            this.setError( 'pagination', err );
        }
    };

    handleFilterChange = async newFilters => {
        this.removeError( 'filters' );

        try {
            this.setPageIndex( 0 );
            this.setFilters( newFilters );
        }
        catch ( err ) {
            console.error( `[CustomerReviews.UpdateFilter Error] ${err}` );
            this.setError( 'filters', err );
        }
    };

    handleFiltersClear = compose( this.handleFilterChange, this.clearFilters );

    openModal = ( modalName, props ) => {
        const {modals} = this.state;
        this.setState( {
            modals: {
                ...modals,
                [modalName]: {isOpen: true, props}
            }
        } );
    };

    closeModal = ( modalName ) => {
        const {modals} = this.state;
        this.setState( {
            modals: {
                ...modals,
                [modalName]: {isOpen: false, props: {}}
            }
        } );
    };

    renderEmpty() {
        return (
            <div className="block w-full">
                <Provider user={this.state.user} test="myContext">
                    <ReviewSummary brandId={this.state.brandId}/>
                </Provider>
            </div>
        );
    }

    render() {
        const {user, brandId, requestCount, modals, filters, errors} = this.state;
        const containerContext = {
            user,
            brandId,
            requestCount,
            modals,
            getPaginationVars: this.getPaginationVars,
            openModal: this.openModal,
            closeModal: this.closeModal
        };
        const actionHandlers = {
            getPaginationVars: this.getPaginationVars,
            handleLoadMore: this.handleLoadMore,
            handleFilterChange: this.handleFilterChange,
            handleFiltersClear: this.handleFiltersClear,
            onEditReview: this.onEditReview,
            filters,
            errors
        };
        
        return (
            <Query
                fetchPolicy="cache-and-network"
                query={GetBrandReviewSummary}
                variables={this.getPaginationVars()}>
                {( {data, error, fetchMore, ...brandReviewSummaryStatus} ) => {

                    // a bit hacky - give context of the "fetchMore" query to the container
                    this.fetchMore = fetchMore;

                    if ( error ) {
                        appLogger.capture( error );
                        console.error( `[BrandReviewSummaryError] ${error}` );
                        return this.renderEmpty();
                    }

                    if ( !data || !data.brandReviewSummary ) {
                        // empty state
                        return this.renderEmpty();
                    }

                    return (
                        <Provider {...containerContext}>
                            <CustomerReviews
                                brandReviewSummary={data.brandReviewSummary}
                                {...brandReviewSummaryStatus}
                                {...actionHandlers}
                            />
                        </Provider>
                    );
                }}
            </Query>
        );
    }
}

export default CustomerReviewsContainer;

